import { render, staticRenderFns } from "./ActionTiles.vue?vue&type=template&id=3bf03606&scoped=true&"
import script from "./ActionTiles.vue?vue&type=script&lang=js&"
export * from "./ActionTiles.vue?vue&type=script&lang=js&"
import style0 from "./ActionTiles.vue?vue&type=style&index=0&id=3bf03606&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf03606",
  null
  
)

export default component.exports